export default __webpack_public_path__ + "static/probono-13a1ad290dfc464c6adee5210101a8ba.png";